import React from 'react';
import MessageItem from './MessageItem';
import ScrollToBottomButton from './ScrollToBottomButton';
import ConversationSummary from './ConversationSummary';
import { Message } from './types';
import { useSmartScroll } from '@/hooks/useSmartScroll';

interface MessageListProps {
  messages: Message[];
  messagesEndRef?: React.RefObject<HTMLDivElement>;
  isLoadingHistory?: boolean;
  currentSessionId?: string;
}

const MessageList: React.FC<MessageListProps> = ({ 
  messages, 
  messagesEndRef, 
  isLoadingHistory = false,
  currentSessionId 
}) => {
  const { scrollContainerRef, showScrollButton, scrollToBottom, handleScroll } = useSmartScroll({
    messages,
    isLoadingHistory,
    currentSessionId,
    threshold: 100
  });

  return (
    <div className="relative flex-1 h-full flex flex-col">
      <ConversationSummary messages={messages} />
      
      <div 
        ref={scrollContainerRef}
        className="flex-1 overflow-y-auto p-4 bg-gray-50"
        onScroll={handleScroll}
      >
        <div className="space-y-4">
          {messages.map(message => (
            <MessageItem 
              key={message.id} 
              message={message}
            />
          ))}
        </div>
        {/* Keep the ref div for backward compatibility */}
        <div ref={messagesEndRef} />
      </div>
      
      <ScrollToBottomButton 
        show={showScrollButton}
        onClick={scrollToBottom}
      />
    </div>
  );
};

export default MessageList;
